import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";

const TCITraineeDetails = (props) => {
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(0);
  const value = useSelector((state) => state.viewDetails);

  const validateTci = (attendedTci) => {
    if (attendedTci != null) {
      if (attendedTci === true) {
        return "Yes";
      } else {
        return "No";
      }
    } else {
      return null;
    }
  };

  const validateTciRecovery = (attendedTciRecovery) => {
    if (attendedTciRecovery != null) {
      if (attendedTciRecovery === true) {
        return "Yes";
      } else {
        return "No";
      }
    } else {
      return null;
    }
  };

  const validationPERRExt = (PERRExtAssignedOverride, PERRExtAssigned) => {
    if (PERRExtAssignedOverride === null || PERRExtAssignedOverride === " ") {
      if (PERRExtAssigned === null) {
        return null;
      } else {
        return PERRExtAssigned === "YES" ? "Yes" : "No";
      }
    } else {
      return PERRExtAssignedOverride === "YES" ? "Yes" : "No";
    }
  };

  useEffect(() => {
    const result = props.data.map((item) => {
      return {
        ...item,
        TCIdate: item.TCIDate
          ? moment(new Date(item.TCIDate)).format("YYYY-MM-DD")
          : "",
        TCIRecoverydate: item.TCIRecoveryDate
          ? moment(new Date(item.TCIRecoveryDate)).format("YYYY-MM-DD")
          : "",
        PERRExtAssigned: validationPERRExt(
          item.PERRExtAssignedOverride,
          item.PERRExtAssigned,
        ),
        PERRExtReason:
          item.PERRExtReasonOverride === null ||
          item.PERRExtReasonOverride === ""
            ? item.PERRExtReason
            : item.PERRExtReasonOverride,
        BuildRebuildStick:
          item.BuildRebuildStickOverride === null ||
          item.BuildRebuildStick === ""
            ? item.BuildRebuildStick
            : item.BuildRebuildStickOverride,
      };
    });

    setData(result);
  }, [props]);

  useEffect(() => {
    setIndex(value.index);
  }, [value]);

  return (
    <>
      {data.length > 0 ? (
        <div>
          <Grid className="p-10px" container spacing={2}>
            <Grid item xs={12} container>
              <Grid item xs={3}>
                Attended TCI :
              </Grid>
              <Grid item xs={9}>
                {data[index].AttendedTCI}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TCI Disposition :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {validateTci(data[index].AttendedTCI)}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                ASD Lead :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].ASDLead}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Build/Rebuild Stick :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].BuildRebuildStick}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TCI Zoom Link and Password :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TCIZoomLink} {data[index].TCIZoomPassword}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TCI Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TCIdate} {data[index].TCITime}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                PERR/Ext Reason :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].PERRExtReason}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                PERR/Ext Assigned :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].PERRExtAssigned}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                Attended TCI Recovery :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {validateTciRecovery(data[index].AttendedTCIRecovery)}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TCI Recovery Date and Time :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TCIRecoverydate} {data[index].TCIRecoveryTime}
              </Grid>
              <Grid item xs={3} sx={{ marginTop: 10 }}>
                TCI Recovery Disposition :
              </Grid>
              <Grid item xs={9} sx={{ marginTop: 10 }}>
                {data[index].TCIRecoveryDisposition}
              </Grid>
            </Grid>
          </Grid>
        </div>
      ) : null}
    </>
  );
};

TCITraineeDetails.propTypes = {
  data: PropTypes.string,
};

export default TCITraineeDetails;
